module.exports = __webpack_public_path__ + "static/media/RefreshGreen2.5cee351f.svg";